var map = {
	"./Cancel.svg": 138,
	"./Containerschiff-1.png": 283,
	"./Dashboard-icon.svg": 139,
	"./Edit-icon-black.svg": 284,
	"./Edit-icon.svg": 285,
	"./Map-icon.svg": 286,
	"./Map.svg": 287,
	"./Message-icon.svg": 107,
	"./Message.svg": 288,
	"./Monitor-icon.svg": 71,
	"./Order-icon.svg": 37,
	"./Polygon-blue.svg": 289,
	"./Polygon-darkBlue.svg": 290,
	"./Polygon-darkGreen.svg": 291,
	"./Polygon-darkPink.svg": 292,
	"./Polygon-grey.svg": 293,
	"./Polygon-orange.svg": 294,
	"./Polygon-red.svg": 295,
	"./Question-stroke-icon.svg": 296,
	"./Settings-icon.svg": 297,
	"./Shopping-cart-icon.svg": 298,
	"./Shopping-cart.svg": 140,
	"./Spinner-1s-200px.gif": 8,
	"./Upload-link.svg": 299,
	"./admin-icon.svg": 300,
	"./arrow-right.svg": 301,
	"./avatar.svg": 302,
	"./block-icons.svg": 303,
	"./cancel-icon.svg": 141,
	"./certificate-01.png": 108,
	"./certificate-02.png": 142,
	"./change-password-ico.png": 159,
	"./chat-box.png": 191,
	"./check-icon.png": 304,
	"./circle_outline_with_exclamation.svg": 143,
	"./correct-icon.svg": 192,
	"./correct.svg": 22,
	"./correct2.svg": 21,
	"./delete-icon.svg": 94,
	"./editpen-icon.svg": 95,
	"./emoji.png": 160,
	"./img01.png": 305,
	"./img02.png": 306,
	"./img03.png": 307,
	"./img04.png": 81,
	"./img05.png": 82,
	"./img06.png": 83,
	"./info-icon.svg": 308,
	"./left-arrow.svg": 52,
	"./location-icon.png": 309,
	"./login-bg.jpg": 65,
	"./logo.png": 43,
	"./logout.svg": 144,
	"./market-img1.png": 193,
	"./market-img2.png": 194,
	"./market-img3.png": 195,
	"./market-img4.png": 196,
	"./market-img5.png": 197,
	"./market-img6.png": 198,
	"./no-image-found.png": 145,
	"./old-login-bg.jpg": 310,
	"./polygon-green.svg": 311,
	"./sidebar-icons/admin.svg": 312,
	"./sidebar-icons/barque.svg": 313,
	"./sidebar-icons/check-list.svg": 314,
	"./sidebar-icons/checked.svg": 315,
	"./sidebar-icons/chef.svg": 316,
	"./sidebar-icons/coupon.svg": 317,
	"./sidebar-icons/customer.svg": 318,
	"./sidebar-icons/dashboard-1.svg": 319,
	"./sidebar-icons/dashboard-interface.svg": 320,
	"./sidebar-icons/dashboard.svg": 321,
	"./sidebar-icons/delivery-truck.svg": 322,
	"./sidebar-icons/department.svg": 323,
	"./sidebar-icons/germany.svg": 324,
	"./sidebar-icons/inventory.svg": 325,
	"./sidebar-icons/label.svg": 326,
	"./sidebar-icons/logout.svg": 327,
	"./sidebar-icons/packages.svg": 328,
	"./sidebar-icons/port.svg": 329,
	"./sidebar-icons/price-tag.svg": 330,
	"./sidebar-icons/review.svg": 331,
	"./sidebar-icons/rudder.svg": 332,
	"./sidebar-icons/ship.svg": 333,
	"./sidebar-icons/upgrade.svg": 334,
	"./sidebar-icons/upload-1.svg": 335,
	"./sidebar-icons/upload.svg": 336,
	"./sidebar-icons/web-browser.svg": 337,
	"./special offer.png": 199,
	"./star.png": 338,
	"./stars-bg.svg": 339,
	"./supplier-icon1.svg": 176,
	"./supplier-icon2.svg": 340,
	"./supplier-logo.png": 42,
	"./svg-loader.svg": 341,
	"./user.svg": 103,
	"./validation-icon.svg": 342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 137;